export const getHomePageUrl = () => {
  const { location } = window;
  return `${location.origin}${process.env.PUBLIC_URL ?? ''}`;
};
